/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Task_TitleInputs */

const cs_automation_task_title = /** @type {(inputs: Automation_Task_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Název úkolu`)
};

const en_automation_task_title = /** @type {(inputs: Automation_Task_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task title`)
};

/**
* | output |
* | --- |
* | "Task title" |
*
* @param {Automation_Task_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_task_title = /** @type {((inputs?: Automation_Task_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Task_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_task_title(inputs)
	return cs_automation_task_title(inputs)
});